import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import {
    floorGameColor as color,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledMedia,
    styledSkeleton,
} from '@pkg/primitives';

interface StyledLoaderProps {
    $failed?: boolean;
}

export const StyledLoader = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})<StyledLoaderProps>`
    display: grid;
    place-items: center;
    place-content: center;
    z-index: 1;
    position: absolute;
    inset: 0;
    background-color: ${color.blackberryDark};

    &::before,
    &::after {
        content: '';
        display: block;
        position: absolute;
        inset: 0;
        opacity: var(--visual-asset-loader-failed-opacity, 0);
        transition: opacity ${duration.normal}ms ${easing.cubic};
    }

    // Failed image background
    &::before {
        z-index: 2;
        background: linear-gradient(134deg, ${color.blackberry} 14%, ${color.grapeDark} 90%);
    }

    // Failed image shine overlay
    &::after {
        z-index: 5;
        background: linear-gradient(45deg, rgb(240, 220, 250, 0), rgb(240, 220, 250, 0.8), rgb(240, 220, 250, 0));
        mix-blend-mode: overlay;
    }

    ${({ $failed }) =>
        $failed &&
        css`
            --visual-asset-loader-failed-opacity: 1;
            --visual-asset-failed-filter: drop-shadow(0 0 6px rgb(146, 118, 250, 0.6));
        `};
`;

export const SkeletonWrapper = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    z-index: 3;
    position: absolute;
    inset: 0;
`;

export const Skeleton = styled.div`
    ${styledSkeleton.baseStyles};
    width: 100%;
    height: 100%;
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    z-index: 4;
    position: relative;
    width: 100%;
    height: 100%;
    color: rgb(255, 255, 255, 0.4);

    svg {
        max-width: 60%;
        filter: var(--visual-asset-failed-filter);
        transition: filter ${duration.normal}ms ${easing.cubic};
    }
`;
